import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="comentarios"
// Handles inline comment creation via JSON API.
export default class extends Controller {
  static targets = ["list", "content", "button"]
  static values = { url: String }

  async create() {
    const texto = this.contentTarget.innerText.trim()
    if (texto === "") return

    this.buttonTarget.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content
        },
        body: JSON.stringify({ texto })
      })

      const data = await response.json()

      if (response.ok) {
        this.listTarget.insertAdjacentHTML("beforeend", data.html)
        this.contentTarget.innerText = ""
      } else {
        alert(data.error || "Erro ao salvar comentario")
      }
    } finally {
      this.buttonTarget.disabled = false
    }
  }
}
